import styled from 'styled-components';

const ServiceTemplateIndividualStyle = styled.section`
	overflow: hidden;

	--distanceTitleContent: var(--sp11x);
	--distanceEveryItemGap: var(--sp6x);

	.title {
		margin-bottom: var(--customDistance2);
		text-transform: uppercase;
	}

	.outside-wrapper-items {
		display: flex;
		flex-direction: column;
		padding-left: calc(var(--contPaddingLR) / 2);

		.wrapper-items {
			display: flex;
			flex-direction: column;
			gap: var(--distanceEveryItemGap);
		}
	}

	.wrapper-services {
		&.active {
			.tag-wrapper {
				opacity: 0;
				animation: tagOpacity 0.3s ease-in forwards;
				animation-delay: calc(((1 + (var(--itemsCount) - 1) * 0.1) + (var(--delayTag) * 0.2)) * 1s);
			}
			.animate {
				animation: slideIn 1s ease-in-out forwards;
				animation-delay: calc(var(--delay) * 0.1s);
			}
		}
	}

	@keyframes tagOpacity {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}

	@keyframes slideIn {
		from {
			transform: translateX(var(--start-position));
		}
		to {
			transform: translateX(0);
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--distanceEveryItemGap: var(--sp5x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--distanceEveryItemGap: var(--sp4x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--distanceEveryItemGap: var(--sp3-5x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--distanceEveryItemGap: var(--sp3x);
	}
`;

export default ServiceTemplateIndividualStyle;
